export function asBoolean(value): boolean {
    if (typeof value === 'boolean') {
        return value
    } else if (typeof value === 'string') {
        switch (value.toLowerCase()) {
            case 'true':
            case '1':
            case 'on':
            case 'yes':
                return true
        }
    } else if (typeof value === 'number' && value === 1) {
        return true
    }
    return false
}
